module.exports = __webpack_public_path__ + "static/media/logo.eb752a2c.svg";